/**
 * "After any refusal" (switch SESSION_REFRESH, "Refresh sign-in").
 *
 * A 403, or the 404 the server's locks answer with, can mean the role the app stored at
 * sign-in is no longer the role the server holds. api/client.ts raises this signal on one;
 * the session keeper (components/layout/SessionKeeper.tsx), with Refresh sign-in on, reads
 * /auth/me again.
 *
 * A module of its own, importing nothing, so the API client can raise it without importing
 * anything that itself goes through the client. Nothing is carried on the signal — no URL,
 * no message — so nothing about the refused request travels further than it did.
 */

const listeners = new Set<() => void>();

/** Listen for refusals. Returns the unsubscribe. */
export function onRefusal(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

/** The server refused a request: the role the app holds may be out of date. */
export function signalRefusal(): void {
  for (const listener of [...listeners]) {
    try { listener(); } catch { /* a listener's failure must not change the request's own error */ }
  }
}
